import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CardHeader } from '../../../models/card-header';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Card } from '../../../models/card';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class CardSearchService {

    session = '';

    public busy$ = new Subject<boolean>();

    constructor(private httpClient: HttpClient, private snackbar: MatSnackBar) {
        this.newSession();
        this.busy$.next(false);
    }

    newSession(): void {
        this.session = (Math.random() * 0xFFFFFFF).toString(16) + (Math.random() * 0xFFFFFFFF);
    }

    query(text: string): Observable<CardHeader[]> {
        const params = new HttpParams()
            .set('q', text)
            .set('session', this.session);
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        this.busy$.next(true);
        return this.httpClient.get<any>(`${environment.apiUrl}/card_search`, { headers, params }).pipe(
            map((result) => result['hydra:member']),
            tap(() => this.busy$.next(false)),
            catchError((error) => {
                this.snackbar.open($localize`Unable to complete searching.  Please try again later.`);
                this.busy$.next(false);
                return [];
            })
        );
    }

    retrieve(id: string): Observable<Card> {
        const params = new HttpParams()
            .set('session', this.session);
        this.busy$.next(true);
        return this.httpClient.get<any>(`${environment.apiUrl}/card_search/${id}`, { params }).pipe(
            tap(() => this.newSession()),
            tap(() => this.busy$.next(false)),
            map((result) => result.data),
            catchError((error) => {
                this.snackbar.open($localize`Unable to retrieve results.  Please try again later.`);
                this.busy$.next(false);
                return [];
            })
        );
    }
}
